import { useEffect, useRef } from "react";

export default function Reveal({ as = "div", children, className = "", delay = 0, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        node.classList.add("is-revealed");
        observer.unobserve(node);
      }
    }, { threshold: 0.12 });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const Element = as;
  return <Element ref={ref} className={`reveal-on-scroll ${className}`} style={{ ...props.style, transitionDelay: `${delay}ms` }} {...props}>{children}</Element>;
}
